import { useState, useEffect } from 'react';
import { SFuncModal } from 'shj-components'
import { Form, Button, Select, Divider, Row, Col, message, Input, Modal } from 'antd';
import { addBusinessMattersDetails,checkBusinessMatters,copyAddBusinessMatters} from '@/services/integrationConfig'
const Option = Select.Option;

export const verifyJSON = (str: any) => {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      if (Object.prototype.toString.call(obj) === '[object Object]') {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
};

export function modalAddOrEditFn({ fn, ...rest }: any) {
  const onClose = () => {
    dialog.destroy();
  };

  const dialog = SFuncModal({
    title: `${rest?.title || '编辑'}`,
    width: 900,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  });

  return dialog;
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }: any) => {
  const { isSee } = rest;
  const [form] = Form.useForm();
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const businessSystemArr = [
    { name: 'FMS', code: 'FMS' },
    { name: 'CRM', code: 'CRM' },
    { name: '供应链', code: 'SUPPLY_CHAIN' },
    { name: '交付', code: 'DELIVERY' },
    { name: 'OMS', code: 'OMS' },
    { name: 'WMS', code: 'WMS' },
    { name: 'HR', code: 'HR' },
    { name: '金蝶', code: 'KINGDEE' },
  ];
  const signArr = [
    { name: '只转不传', code: 'only_transfer' },
    { name: '只传不转', code: 'only_send' },
    { name: '又转又传', code: 'both_transfer_and_send' },
  ];
  let [actionTypeArr, setActionTypeArr] = useState([
    { name: '新增', code: 'add' },
    { name: '提交', code: 'submit' },
    { name: '更新（要反审核）', code: 'update_with_review' },
    { name: '更新（不反审核）', code: 'update_without_review' },
    { name: '下推', code: 'push_down' },
    { name: '批量保存', code: 'batch_save' },
    { name: '批量下推', code: 'batch_push_down' },
    { name: '查询', code: 'query' },
    { name: '反确认', code: 'un_confirm' },
  ]);
  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    const { code, name, businessSystem, status, businessParamJson, transferFlag, actionType, businessType, remark } =
      rest;
    // 回显数据
    if (rest?.id) {
      console.log(rest?.copy ? '' : actionType);
      form.setFieldsValue({
        code,
        name,
        businessSystem,
        status,
        businessParamJson,
        transferFlag,
        actionType: rest?.copy ? '' : actionType,
        businessType,
        remark,
      });
      if (rest.copy && actionType) {
        let arr = actionTypeArr.filter((e) => e.code !== actionType);
        setActionTypeArr(arr);
      }
    }
  };

  // 提交
  const onFinish = (values: any) => {
    try {
      let newValues = { ...values };
      const { id } = rest;
      setAddOrEditFooterLoading(true);
      if (id) {
        newValues.id = id;
        if (!newValues.status) {
          hasRule(id, newValues);
          return;
        }
      }
      onSend(newValues);
    } catch (e) {
      setAddOrEditFooterLoading(false);
    }
  };
  const onSend = (newValues: any) => {
    addBusinessMattersDetails(newValues).then((response: any) => {
        setAddOrEditFooterLoading(false);
        message.info(response?.message || '操作成功');
        onClose();
        fn && fn();
      })
      .catch(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  const hasRule = (id: string | number, newValues: any) => {
    checkBusinessMatters(id).then((resp: any) => {
        if (resp) {
          showTip(newValues);
        } else {
          onSend(newValues);
        }
      })
      .catch(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  const showTip = (newValues: any) =>
    Modal.confirm({
      title: '此业务事项下有规则，是否一起禁用',
      content: '',
      centered: true,
      okText: '确定',
      cancelText: '取消',
      onOk: () => {
        onSend(newValues);
      },
      onCancel: () => {
        setAddOrEditFooterLoading(false);
      },
    });

  const validateFormat = (rule: any, value: any, callback: any) => {
    let flag = verifyJSON(value);
    if (flag) {
      callback();
    } else {
      callback('请输入json格式内容');
    }
  };
  // const validateCode = (rule: any, value: any, callback: any) => {
  //   const patt1 = /YWSX[0-9]{4}/;
  //   if (value && value.match(patt1)) {
  //     callback();
  //   } else {
  //     callback('编码规则:YWSX+4位流水号');
  //   }
  // };
  const onCopy = (values: Record<string, any>) => {
    setAddOrEditFooterLoading(true);
    copyAddBusinessMatters({
      id: rest.id,
      status: rest.status,
      actionType: values?.actionType,
    }).then((resp: any) => {
        message.success(resp?.message || '操作成功');
        onClose();
        fn && fn();
        setAddOrEditFooterLoading(false);
      })
      .catch(() => {
        setAddOrEditFooterLoading(false);
      });
  };
  return (
    <div>
      <Form
        form={form}
        layout={'vertical'}
        onFinish={rest?.copy ? onCopy : onFinish}
        initialValues={{ status: true }}
        style={{ padding: 15 }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="业务事项编码" name="code" rules={[{ required: true, message: '请输入业务事项编码' }]}>
              <Input disabled={rest.id} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="业务事项名称" name="name" rules={[{ required: true, message: '请输入业务事项名称' }]}>
              <Input disabled={isSee} />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="业务系统" name="businessSystem" rules={[{ required: false, message: '请输入业务系统' }]}>
              <Select disabled={isSee}>
                {businessSystemArr.map((item) => {
                  return (
                    <Option key={item.code} value={item.code}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="状态" name="status" rules={[{ required: true, message: '请选择状态' }]}>
              <Select disabled={isSee}>
                <Option value={true}>启用</Option>
                <Option value={false}>禁用</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="转传标志" name="transferFlag" rules={[{ required: true, message: '请选择转传标志' }]}>
              <Select disabled={isSee}>
                {signArr.map((item) => {
                  return (
                    <Option key={item.code} value={item.code}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="动作类型" name="actionType" rules={[{ required: true, message: '请选择动作类型' }]}>
              <Select disabled={rest.id && !rest.copy}>
                {actionTypeArr.map((item) => {
                  return (
                    <Option key={item.code} value={item.code}>
                      {item.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="业务类型" name="businessType" rules={[{ required: true, message: '请选择业务类型' }]}>
              <Input disabled={isSee && !rest.copy} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="备注" name="remark">
              <Input disabled={isSee} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              labelCol={{ span: 3 }}
              label="业务参数"
              name="businessParamJson"
              rules={[{ required: true }, { validator: validateFormat }]}
            >
              <Input.TextArea rows={10} disabled={isSee} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row>
            <Col span={24}>
              <Divider />
            </Col>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button htmlType="button" onClick={onClose} style={{ marginLeft: '8px' }}>
                取消
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ margin: '0 8px' }}
                disabled={addOrEditFooterLoading || (isSee && !rest.copy)}
                loading={addOrEditFooterLoading}
              >
                提交
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </div>
  );
};
